'use client'

import { useSession } from '@/shared/ui/providers/AuthSessionProvider'
import { useGetMyInfosQuery } from '@/core/graphql/hooks'
import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { useMemo } from 'react'

import { useBooking } from '../../model/bookingContext'
import { BookingStepEnum } from '../../model/bookingTypes'
import { BookingStep } from './BookingStep'
import { IncompletedStepLabel } from './IncompletedStepLabel'
import { PatientInfoForm } from './PatientInfoForm'
import { Summary } from './Summary'
import { AuthenticationGate } from '../AuthenticationGate'

export function PatientInfoStep() {
  const { data: session } = useSession()
  const { data: myInfosData } = useGetMyInfosQuery({ skip: !session?.user })
  const { state, goToStep, isStepCompleted } = useBooking()

  const initialValues = useMemo(() => {
    if (!session?.user) return null

    if (state.patientInfo.firstName && state.patientInfo.lastName && state.patientInfo.email) {
      return { ...state.patientInfo, isCarteVitaleAvailable: false, isGCUAccepted: false }
    }

    const myInfos = myInfosData?.myInfos
    return {
      firstName: myInfos?.userInfo?.name || session.user.name?.split(' ')[0] || '',
      lastName: myInfos?.userInfo?.surname || session.user.name?.split(' ').slice(1).join(' ') || '',
      email: myInfos?.email || session.user.email || '',
      phone: myInfos?.contactInfo?.phone || '',
      isCarteVitaleAvailable: false,
      isGCUAccepted: false,
    }
  }, [session, state.patientInfo, myInfosData])

  // useEffect(() => {
  //   const { user } = session ?? {}

  //   if (!isLoggedIn || !user) return

  //   // If user is logged in, we can skip this step and go to the next one
  //   // Make sure we have the patient info in the context

  //   // Add a flag to prevent redirect loops
  //   const hasSkipped = sessionStorage.getItem('skippedPatientInfo')

  //   if (!state.patientInfo.firstName || !state.patientInfo.lastName || !state.patientInfo.email) {
  //     dispatch({
  //       type: 'SET_PATIENT_INFO',
  //       payload: {
  //         firstName: user.name?.split(' ')[0] || '',
  //         lastName: user.name?.split(' ').slice(1).join(' ') || '',
  //         email: user.email || '',
  //       },
  //       goToNextStep: !hasSkipped,
  //     })
  //     sessionStorage.setItem('skippedPatientInfo', 'true')
  //     console.log('User is logged in, skipping patient information step')
  //   }

  //   // Clean up the skip flag when component unmounts
  //   return () => {
  //     sessionStorage.removeItem('skippedPatientInfo')
  //   }
  // }, [status, state.formSubmissionId, dispatch, isLoggedIn, session, state.patientInfo])

  if (state.currentStep === BookingStepEnum.PATIENT_INFORMATION) {
    return (
      <BookingStep className="sm:!rounded-br-none">
        <BookingStep.Title>
          <Trans>Patient information</Trans>
        </BookingStep.Title>
        <BookingStep.Content>
          <AuthenticationGate returnPath={`/meeting-links/${state.meetingLinkSlug}/booking`}>
            {initialValues ? <PatientInfoForm initialValues={initialValues} meetingLinkSlug={state.meetingLinkSlug} /> : null}
          </AuthenticationGate>
        </BookingStep.Content>
      </BookingStep>
    )
  }

  if (isStepCompleted(BookingStepEnum.PATIENT_INFORMATION)) {
    return (
      <Summary
        icon="👤"
        label={t`Patient information`}
        onEdit={() => goToStep(BookingStepEnum.PATIENT_INFORMATION)}
        text={`${state.patientInfo.firstName} ${state.patientInfo.lastName}`}
      />
    )
  }

  return (
    <IncompletedStepLabel icon="👤">
      <Trans>Patient information</Trans>
    </IncompletedStepLabel>
  )
}
